import React from 'react';
import {render} from 'react-dom'

var Header = React.createClass({
	render: function(){
		return(
		   <div className="diff__row">
	        <div className="diff__col diff__col--left diff__col--top">Download &amp; overwrite {this.props.selectedFiles} of {this.props.totalFiles} out-of-sync files</div>
	        <div className="diff__col diff__col--right diff__col--top">
	          <div className="diff__path tooltip__container"><span>{this.props.activeFile} </span> <div className="tooltip tooltip--top tooltip--md">{this.props.activeFile}</div></div>
	          <ul className="diff__location">
	            <li><span className="hint__box hint__box--green"></span> <span>= Remote</span></li>
	            <li><span className="hint__box hint__box--pink"></span> <span>= Local</span></li>
	          </ul>
	        </div>
	      </div>
		);
	}
});

export {Header};


/** WEBPACK FOOTER **
 ** ./html/components/DetailsPage/DiffPullPopup/Header.jsx
 **/